import { addPageToViewed } from '../../redux/actions/ui/addPageToViewed';
import defaultLayout from '../../config/templates/layouts/default.json';
import { setFetchDefaults } from '../actions/entities/io';
import { loadBook } from './../../redux/helpers/loadBook';
import { loadSpineDefaults } from '../actions/entities/cover';


// Templates
import loadTemplates from '../../config/templates/layouts/index';

import {
  loadLayouts,
  setIsActiveLayout,
  removeDefaultLayout,
} from '../actions/entities/layouts';

import {
  setLayoutToActivePage,
  setIsActive,
  createPage,
} from '../actions/entities/pages';

import {
  getParams,
  getDomain,
} from './getParams';

import {
  addBookId,
  addContext,
  addFolderId,
  saveBookSizes,
  getBookDimensions,
  addAutoFill,
  maxSheets,
  addCalendarMonth,
  addCalendarYear,
} from '../actions/bookproperties';

import {
  configExist,
  MmToPx,
  getRatio,
  getCoverOrientation,
  loadDefaultImages,
  showAlertModal,
} from './';

export function setFirstLayout(store, layoutId, pageId) {
  store.dispatch(setLayoutToActivePage(layoutId, pageId));
  store.dispatch(setIsActiveLayout(layoutId));
  store.dispatch(loadSpineDefaults());
  store.dispatch(setFetchDefaults());
  store.dispatch(setIsActive(pageId));
}

function coverOrientation(pageWidth, pageHeight) {
  return getCoverOrientation(pageWidth, pageHeight);
}


// Load Gallery
function loadGalleryImages(store, referer, bookId, lang, maxSheets, autoFill, context = 'pro') {
  const url = configExist('legacyContent', referer);
  const parameters = 'api/calendar/';
  const galleryURI = `${url}/${parameters}${bookId}/galleries`;
  fetch(galleryURI, {
    cors: 'no-cors',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    credentials: 'include',
  })
    .then(response => response.json())
    .then((galleryData) => {
      if ('error' in galleryData) {
        throw galleryData.error;
      }
      loadDefaultImages(galleryData, store);
    })
    .then(() => {
     
        showAlertModal(lang.select_background, '', '');
      
    });
}


/* // Get year, month images
async function getDateImages() {
  const dImages = await fetch('http://demo2402769.mockable.io/dateImages')
    .then(images => images.json())
    .then(response => response);
  return dImages;
} */

// Creat new empty book
async function setNewBook(store, response, layoutId, bookId, pageId, referer, lang, autoFill) {
  const { pageHeight, pageWidth } = response.dimensions;
  const format = coverOrientation(pageWidth, pageHeight);
  const { maxSheets, month, year } = response;
  store.dispatch(addBookId(parseInt(bookId, 10)));
  const pageType = loadTemplates;

  store.dispatch(removeDefaultLayout(layoutId));
  const layoutTemplates = pageType[format];
  for (const layout of layoutTemplates.items) {
    store.dispatch(loadLayouts(layout.layouts));
  }

  const getDImages = '';
  loadGalleryImages(store, referer, bookId, lang, maxSheets, autoFill, getParams('context'));
  store.dispatch(addPageToViewed(10));
  store.dispatch(addCalendarYear(year));
  store.dispatch(addCalendarMonth(month));
  for (let i = 1; i < (maxSheets); i++) {
    store.dispatch(createPage({ order: (i) }));
  }

  const { allIds } = store.getState().entities.pages;
  allIds.forEach(element => store.dispatch(setLayoutToActivePage(layoutId, element, false, false, getDImages, true)));
}


export function loadDefaultState(store, bookId = false, autoFill = false, bookContext, lang) {
  for (const layout of defaultLayout.items) {
    store.dispatch(loadLayouts(layout.layouts));
  }
  const referer = getDomain();

  const page = {
    layout: 0,
    placeholders: [],
    order: 0,
    isActive: false,
  };
  store.dispatch(createPage(page));

  // set first layout to first page
  const [layoutId] = store.getState().entities.layouts.allIds.slice(0, 1);
  const [pageId] = store.getState().entities.pages.allIds.slice(0, 1);
  setFirstLayout(store, layoutId, pageId);

  // Load book properties
  const getBookProperties = configExist('getStateUrl', referer);
  // const fetchURL = `${getBookProperties}/${bookId}`;
  const fetchURL = `${getBookProperties}/${bookId}`;
  fetch(
    fetchURL,
    {
      cors: 'no-cors',
      credentials: 'include',
    },
  )
    .then(response => response.json())
    .then((data) => {
      if ('error' in data) {
        throw data.error;
      }
      const {
        pageWidth,
        pageHeight,
      } = data.bookID.dimensions;
      const { folderID } = data.bookID;

      const getAutofill = false;
      store.dispatch(getBookDimensions(data.bookID.dimensions));
      store.dispatch(addFolderId(folderID));
      store.dispatch(addAutoFill(getAutofill));
      store.dispatch(maxSheets(parseInt(data.bookID.maxSheets, 10)));

      const pHeight = MmToPx(pageHeight);
      const pWidth = MmToPx(pageWidth);

      const { layoutHeight } = store.getState().bookProperties.dimensions;
      store.dispatch(saveBookSizes(pWidth, pHeight, data.margin, getRatio(layoutHeight, pHeight)));

      return data.bookID;
    }).then((response) => {
      const legacyContent = configExist('legacyContent', referer);
      fetch(`${legacyContent}/api/calendar/${bookId}/editorjson`, {
        cors: 'no-cors',
        credentials: 'include',
      })
        .then(response => response.json())
        .then((data) => {
          // Empty book
          if (('error' in data) || ('json' in data && data.json === null)) {
            // if ((data.error === 422)) {
            store.dispatch(addContext(bookContext));
            setNewBook(store, response, layoutId, bookId, pageId, referer, lang, autoFill);
            // } else {
            //  showAlertModal(lang.title_notice, lang.authentication_required);
            // }
          } else {
          // Load saved book
            const url = configExist('legacyContent', referer);
            const parameters = 'api/calendar/';
            const filterType = '';
            const galleryURI = `${url}/${parameters}${bookId}/galleries${filterType}`;
            store.dispatch(loadBook(galleryURI, response, store, lang, data));
            store.dispatch(addContext(bookContext));
          }
        });
    });
}



// WEBPACK FOOTER //
// ./src/redux/helpers/loadDefaulState.js